import { useState } from 'react';
import '../Styles/Work.css'
import Proekt1 from '../Images/kako.PNG'
import Proekt2 from '../Images/ttelo.png'
import Proekt3 from '../Images/Bez-nazwy-2.png'
import tahlil from '../Images/tahlil.png'
import Qorabuloq from '../Images/Screenshot_1.png'
import Adara from '../Images/adara.png'
import Carousel from './Carousel';
export default function () {


  return (
    <>
      <div data-aos="fade-right">
        <section className="work" >
          <div className="container">
            <div className="text-work">
              <h1 className='primary-text'>

                <div data-aos="flip-right">
                  <span className="blast">M</span>
                  <span className="blast">y</span>
                  <span className="blast"> ⠀</span>
                  <span className="blast">P</span>
                  <span className="blast">o</span>
                  <span className="blast">r</span>
                  <span className="blast">t</span>
                  <span className="blast">f</span>
                  <span className="blast">o</span>
                  <span className="blast">l</span>
                  <span className="blast">i</span>
                  <span className="blast">o</span>
                </div>
              </h1>
              <p className="about-text">
                <div data-aos="flip-up">A small gallery of recent projects chosen by me. I've done them all together with amazing people from companies around the globe. It's only a drop in the ocean compared to the entire list.
                  interested to see some more? Visit my work page </div></p>
              <a href="#" className="contact-button">
                <div>
                  <span className="bg" ></span>
                  <span className="base"></span>
                  <span className="text">
                    <div data-aos="flip-left">     More Projects</div>
                  </span>
                </div>
              </a>
            </div>
          </div>
          <div className="works">
            <div class="card__collection clear-fix">
              <div class="cards cards--three">
                <img src={Adara} class="img-responsive" alt="" />
                  <span class="cards--three__rect-1">
                    <span class="shadow-1"></span>
                    <p>Adara Shop</p>
                  </span>
                  <span class="cards--three__rect-2">
                    <span class="shadow-2"></span>
                  </span>
                  <span class="cards--three__circle"></span>
                  <ul class="cards--three__list">
                    <li>Viev Code</li>
                  </ul>
              </div>
              <div class="cards cards--three">
                <img src={Qorabuloq} class="img-responsive" alt="" />
                  <span class="cards--three__rect-1">
                    <span class="shadow-1"></span>
                    <p>Qorabuloq</p>
                  </span>
                  <span class="cards--three__rect-2">
                    <span class="shadow-2"></span>
                  </span>
                  <span class="cards--three__circle"></span>
                  <ul class="cards--three__list">
                    <li>View  Code</li>
                  </ul>
              </div>
              <div class="cards cards--three">
                <img src={tahlil} class="img-responsive" alt="" />
                  <span class="cards--three__rect-1">
                    <span class="shadow-1"></span>
                    <p>Tahlil 24</p>
                  </span>
                  <span class="cards--three__rect-2">
                    <span class="shadow-2"></span>
                  </span>
                  <span class="cards--three__circle"></span>
                  <ul class="cards--three__list">
                    <li>View Code</li>
                  </ul>
              </div>
            </div>
          </div>
          <div className="carousel-project">
            <Carousel />
          </div>

        </section>
      </div>
    </>);
}
